(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-color-media"] && !Shopify.designMode) return;
  try {
    (function () {
    // Trailing color code ("8906-9" -> "9"), used as a typo-tolerant fallback
    // when matching the ymq swatch value against metafield color keys.
    function codeOf(s) {
      var i = String(s).lastIndexOf('-');
      return i > -1 ? String(s).slice(i + 1).trim() : '';
    }

    function initOverlay(root) {
      if (root.dataset.colorMediaReady === '1') return;
      root.dataset.colorMediaReady = '1';

      var jsonEl = root.querySelector('[data-color-media-json]');
      var stage = root.querySelector('[data-color-media-stage]');
      if (!jsonEl || !stage) return;

      var templates = {};
      root.querySelectorAll('template[data-color-media-set]').forEach(function (t) {
        templates[t.getAttribute('data-color-media-set')] = t;
      });
      var keys = Object.keys(templates);
      if (keys.length === 0) return;

      var mediaRoot = root.closest('.product-media');
      var active = null; // current template key, null = native gallery

      function lookup(value) {
        if (!value) return null;
        if (templates[value]) return value;
        var code = codeOf(value);
        if (!code) return null;
        for (var i = 0; i < keys.length; i++) {
          if (codeOf(keys[i]) === code) return keys[i];
        }
        return null;
      }

      function deactivate() {
        if (active === null) return;
        // Videos keep playing (with sound) after being detached — pause first.
        stage.querySelectorAll('video').forEach(function (v) {
          try { v.pause(); } catch (e) {}
        });
        stage.innerHTML = '';
        if (mediaRoot) mediaRoot.removeAttribute('data-color-media-on');
        root.hidden = true;
        active = null;
      }

      function activate(name) {
        var key = lookup(name);
        if (key === null) {
          deactivate();
          return;
        }
        if (active === key) return; // idempotent
        deactivate();
        // Unhide before inserting so the theme's media-carousel /
        // scroll-carousel components measure real layout on connect.
        root.hidden = false;
        if (mediaRoot) mediaRoot.setAttribute('data-color-media-on', '');
        stage.appendChild(templates[key].content.cloneNode(true));
        active = key;
      }

      // ----- ymq selection wiring (same triple net as product-color-videos) -----
      function selectedColorValue() {
        var marked = document.querySelectorAll('input[ymq-option-checked="true"]');
        for (var i = 0; i < marked.length; i++) {
          if (lookup(marked[i].value)) return marked[i].value;
        }
        var checked = document.querySelectorAll('input[type="radio"]:checked');
        for (var j = 0; j < checked.length; j++) {
          if (lookup(checked[j].value)) return checked[j].value;
        }
        return null;
      }
      function syncFromSelection() {
        var val = selectedColorValue();
        if (val != null) activate(val);
        else deactivate();
        return val != null;
      }

      document.addEventListener(
        'click',
        function (e) {
          if (!e.target.closest || !e.target.closest('[class*="ymq-option"]')) return;
          setTimeout(syncFromSelection, 120);
        },
        true
      );

      var container = document.querySelector('#product-detail-vue') || document.body;
      var scheduled = false;
      try {
        new MutationObserver(function () {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(function () {
            scheduled = false;
            syncFromSelection();
          });
        }).observe(container, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['ymq-option-checked', 'checked', 'class', 'aria-checked'],
        });
      } catch (e) {}

      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (syncFromSelection() || tries > 40) clearInterval(iv);
      }, 500);
    }

    function initAll() {
      document.querySelectorAll('[data-color-media-overlay]').forEach(initOverlay);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-color-videos"] && !Shopify.designMode) return;
  try {
    (function () {
    function norm(s) {
      return (s == null ? '' : String(s)).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    // Extract the trailing color code, e.g. "Ivory White 8906-9" -> "8906-9".
    function code(s) {
      var m = norm(s).match(/(\d{3,5}-\d{1,3})/);
      return m ? m[1] : null;
    }

    var ICON_PLAY =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg>';
    var ICON_PREV =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4L10.8 12z"></path></svg>';
    var ICON_NEXT =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.6 16.6 10 18l6-6-6-6-1.4 1.4L13.2 12z"></path></svg>';
    var ICON_CLOSE =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
    var ICON_EXPAND =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3H3v6h2V5h4V3zm12 0h-6v2h4v4h2V3zM5 15H3v6h6v-2H5v-4zm16 0h-2v4h-4v2h6v-6z"></path></svg>';
    var ICON_SOUND =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13 3a4 4 0 0 0-2-3.46v6.92A4 4 0 0 0 16 12z"></path></svg>';
    var ICON_MUTED =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z"></path><path fill="none" stroke-width="2" stroke-linecap="round" d="M15 9.5l5 5m0-5l-5 5"></path></svg>';

    function initBlock(root) {
      if (root.dataset.colorVideoReady === '1') return;
      root.dataset.colorVideoReady = '1';

      var dataEl = root.querySelector('.color-video-data');
      var stage = root.querySelector('.color-video-stage');
      if (!dataEl || !stage) return;

      var map;
      try {
        map = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var colors = (map && map.colors) || {};
      var debug = root.getAttribute('data-debug') === 'true';

      var L = {
        close: root.dataset.i18nClose || 'Close',
        prev: root.dataset.i18nPrev || 'Previous',
        next: root.dataset.i18nNext || 'Next',
        play: root.dataset.i18nPlay || 'Play video',
        mute: root.dataset.i18nMute || 'Mute',
        unmute: root.dataset.i18nUnmute || 'Unmute',
        gotoTpl: root.dataset.i18nGoto || 'Go to item %i'
      };
      function gotoLabel(n) {
        return L.gotoTpl.replace('%i', n);
      }

      // The `__default__` entry is shown when no color is selected/matched.
      var DEFAULT_KEY = '__default__';

      // Turn raw video entries into media items. Use a cover image directly when
      // the metafield provides one (various tools name the field differently);
      // the first frame is used as a fallback cover otherwise. Also derive a CSS
      // aspect-ratio from the entry's dimensions when present so the box can be
      // reserved before the video loads (falls back to the 576x1024 default).
      function toMedia(vids) {
        return (vids || [])
          .map(function (v) {
            if (!v || !v.url) return null;
            // Only play finished transcodes (status: READY); PROCESSING/FAILED/
            // UNKNOWN are skipped. Tolerate older entries with no status field.
            if (v.status && v.status !== 'READY') return null;
            var poster =
              v.poster ||
              v.poster_url ||
              v.thumbnail ||
              v.thumbnail_url ||
              v.preview ||
              v.preview_image ||
              v.image ||
              null;
            var aspect = v.aspect_ratio || v.aspect || null;
            var w = v.width || v.w;
            var h = v.height || v.h;
            if (!aspect && w && h) aspect = w + ' / ' + h;
            return { url: v.url, poster: poster, aspect: aspect, posterData: null, waiters: [] };
          })
          .filter(Boolean);
      }

      // Index colors by normalized name and by color code (ready URLs only).
      var byName = {};
      var byCode = {};
      var withVideo = [];
      Object.keys(colors).forEach(function (key) {
        var urls = toMedia(colors[key] && colors[key].videos);
        var entry = { key: key, nKey: norm(key), urls: urls };
        byName[entry.nKey] = entry;
        if (key !== DEFAULT_KEY) {
          var c = code(key);
          if (c) byCode[c] = entry;
          if (urls.length) withVideo.push(key);
        }
      });

      // `__default__` may be placed inside `colors` or at the top level.
      var defaultEntry = byName[norm(DEFAULT_KEY)] || null;
      if (!defaultEntry && map && map[DEFAULT_KEY]) {
        defaultEntry = {
          key: DEFAULT_KEY,
          nKey: norm(DEFAULT_KEY),
          urls: toMedia(map[DEFAULT_KEY] && map[DEFAULT_KEY].videos)
        };
      }

      if (debug) console.log('[color-video] colors with video:', withVideo);
      var hasDefault = !!(defaultEntry && defaultEntry.urls.length);
      if (!withVideo.length && !hasDefault) {
        root.style.display = 'none';
        return;
      }

      var opts = {
        loop: root.getAttribute('data-loop') === 'true',
        controls: root.getAttribute('data-controls') === 'true'
      };

      var sets = {}; // nKey -> { el, videos }; built once per color.
      var activeKey = null;

      function lookup(value) {
        if (value == null) return null;
        var entry = byName[norm(value)];
        if (entry) return entry;
        var c = code(value);
        if (c && byCode[c]) return byCode[c];
        return null;
      }

      // ----- Cover sharing: a frame captured for an inline preview is reused
      // by the coverflow card for the same video (and vice-versa). -----
      function setPoster(media, data) {
        media.posterData = data;
        (media.waiters || []).forEach(function (el) {
          if (!el.poster) el.poster = data;
        });
        media.waiters = [];
      }
      function usePoster(el, media) {
        if (media.posterData) el.poster = media.posterData;
        else if (media.poster) el.poster = media.poster;
        else (media.waiters = media.waiters || []).push(el);
      }

      function safePlay(v) {
        try {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } catch (e) {}
      }
      function inViewport(el) {
        var r = el.getBoundingClientRect();
        return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
      }

      // Autoplay inline previews only while they're on screen (and the overlay
      // is closed), to limit how many videos decode at once.
      var io =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              function (entries) {
                entries.forEach(function (en) {
                  if (en.isIntersecting && !cfOpen) safePlay(en.target);
                  else
                    try {
                      en.target.pause();
                    } catch (e) {}
                });
              },
              { threshold: 0.25 }
            )
          : null;

      // Derive a cover from a (muted, autoplaying) video's first real frame and
      // share it. Needs CORS to avoid a tainted canvas; Shopify's CDN sends
      // Access-Control-Allow-Origin: *.
      function captureFromPlayback(v, media) {
        var done = false;
        var corsRetried = false;
        var tries = 0;
        var MAX_TRIES = 90;

        function frameIsBlank() {
          try {
            var s = document.createElement('canvas');
            s.width = 16;
            s.height = 16;
            var sx = s.getContext('2d');
            sx.drawImage(v, 0, 0, 16, 16);
            var px = sx.getImageData(0, 0, 16, 16).data;
            var max = 0;
            for (var i = 0; i < px.length; i += 4) {
              if (px[i] > max) max = px[i];
              if (px[i + 1] > max) max = px[i + 1];
              if (px[i + 2] > max) max = px[i + 2];
            }
            return max < 12;
          } catch (e) {
            return false;
          }
        }
        function grab() {
          if (done) return;
          if (!v.videoWidth || !v.videoHeight) return;
          tries++;
          if (frameIsBlank()) {
            if (tries < MAX_TRIES) arm();
            return;
          }
          try {
            var canvas = document.createElement('canvas');
            canvas.width = v.videoWidth;
            canvas.height = v.videoHeight;
            canvas.getContext('2d').drawImage(v, 0, 0, canvas.width, canvas.height);
            var data = canvas.toDataURL('image/jpeg', 0.8);
            if (data && data.indexOf('data:image/jpeg') === 0) {
              v.poster = data;
              setPoster(media, data);
            }
          } catch (e) {}
          done = true;
        }
        function arm() {
          if (typeof v.requestVideoFrameCallback === 'function')
            v.requestVideoFrameCallback(function () {
              grab();
            });
        }
        v.addEventListener('loadeddata', arm);
        v.addEventListener('timeupdate', function () {
          if (v.currentTime > 0) grab();
        });
        v.addEventListener('error', function () {
          if (corsRetried || !v.crossOrigin) return;
          corsRetried = true;
          done = true; // can't snapshot a non-CORS source; just keep playback
          v.removeAttribute('crossorigin');
          var s = v.src;
          v.removeAttribute('src');
          v.load();
          v.src = s;
        });
      }

      // ----- Inline previews (one autoplaying, muted row per color) -----
      function buildSet(entry) {
        var setEl = document.createElement('div');
        setEl.className = 'color-video-set';
        var videos = [];
        entry.urls.forEach(function (media, i) {
          var item = document.createElement('button');
          item.type = 'button';
          item.className = 'color-video-item';
          item.setAttribute('aria-label', L.play);

          var v = document.createElement('video');
          v.className = 'color-video-el';
          v.setAttribute('playsinline', '');
          v.muted = true;
          v.loop = true;
          v.autoplay = true;
          v.preload = 'auto';
          if (media.aspect) v.style.setProperty('--color-video-aspect', media.aspect);

          var willCapture = !media.poster && !media.posterData;
          if (willCapture) v.crossOrigin = 'anonymous';
          usePoster(v, media);
          v.src = media.url;
          if (willCapture) captureFromPlayback(v, media);

          var hint = document.createElement('span');
          hint.className = 'color-video-play';
          hint.innerHTML = ICON_EXPAND;

          item.appendChild(v);
          item.appendChild(hint);
          item.addEventListener('click', function () {
            openOverlay(entry, i);
          });
          setEl.appendChild(item);
          videos.push(v);
          if (io) io.observe(v);
        });
        return { el: setEl, videos: videos };
      }

      function hideActive() {
        if (!activeKey || !sets[activeKey]) return;
        sets[activeKey].el.classList.remove('is-active');
        sets[activeKey].videos.forEach(function (v) {
          try {
            v.pause();
          } catch (e) {}
        });
      }

      function show(entry) {
        if (!entry || !entry.urls.length) return;
        if (activeKey === entry.nKey) return;
        hideActive();
        if (!sets[entry.nKey]) {
          sets[entry.nKey] = buildSet(entry);
          stage.appendChild(sets[entry.nKey].el);
        }
        sets[entry.nKey].el.classList.add('is-active');
        activeKey = entry.nKey;
        if (!cfOpen)
          sets[entry.nKey].videos.forEach(function (v) {
            if (inViewport(v)) safePlay(v);
          });
        if (debug) console.log('[color-video] showing', entry.key);
      }

      function clear() {
        hideActive();
        activeKey = null;
      }
      function showDefault() {
        if (defaultEntry && defaultEntry.urls.length) show(defaultEntry);
        else clear();
      }
      function applyColor(value) {
        var entry = lookup(value);
        if (debug)
          console.log('[color-video] selected =', value, '=> match:', entry && entry.key);
        if (entry && entry.urls.length) show(entry);
        else showDefault();
      }
      function activeInlineVideos() {
        return activeKey && sets[activeKey] ? sets[activeKey].videos : [];
      }

      // =====================================================================
      // Fullscreen coverflow overlay (one per block, built lazily, on <body>).
      // =====================================================================
      var cfEl = null,
        cfTrack = null,
        cfDots = null,
        cfPrevBtn = null,
        cfNextBtn = null,
        cfMuteBtn = null;
      var cfCards = [],
        cfVids = [],
        cfDotEls = [];
      var cfActive = 0,
        cfOpen = false,
        cfMuted = true,
        cfPendingTimer = null,
        cfLastSwipe = 0,
        cfTouchX = 0,
        cfTouchY = 0,
        cfTouchMoved = false;

      function updateMuteBtn() {
        if (!cfMuteBtn) return;
        cfMuteBtn.innerHTML = cfMuted ? ICON_MUTED : ICON_SOUND;
        cfMuteBtn.setAttribute('aria-label', cfMuted ? L.unmute : L.mute);
      }

      function cfEnsure() {
        if (cfEl) return;
        cfEl = document.createElement('color-video-coverflow');
        cfEl.className = 'cvf';
        cfEl.setAttribute('aria-hidden', 'true');

        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'cvf__close';
        close.setAttribute('aria-label', L.close);
        close.innerHTML = ICON_CLOSE;
        close.addEventListener('click', cfClose);

        cfMuteBtn = document.createElement('button');
        cfMuteBtn.type = 'button';
        cfMuteBtn.className = 'cvf__mute';
        cfMuteBtn.addEventListener('click', function () {
          cfMuted = !cfMuted;
          cfVids.forEach(function (v) {
            v.muted = cfMuted;
          });
          updateMuteBtn();
        });
        updateMuteBtn();

        cfPrevBtn = document.createElement('button');
        cfPrevBtn.type = 'button';
        cfPrevBtn.className = 'cvf__nav cvf__nav--prev';
        cfPrevBtn.setAttribute('aria-label', L.prev);
        cfPrevBtn.innerHTML = ICON_PREV;
        cfPrevBtn.addEventListener('click', function () {
          cfGoTo(cfActive - 1);
        });

        cfNextBtn = document.createElement('button');
        cfNextBtn.type = 'button';
        cfNextBtn.className = 'cvf__nav cvf__nav--next';
        cfNextBtn.setAttribute('aria-label', L.next);
        cfNextBtn.innerHTML = ICON_NEXT;
        cfNextBtn.addEventListener('click', function () {
          cfGoTo(cfActive + 1);
        });

        var stageEl = document.createElement('div');
        stageEl.className = 'cvf__stage';
        cfTrack = document.createElement('div');
        cfTrack.className = 'cvf__track';
        stageEl.appendChild(cfTrack);

        cfDots = document.createElement('div');
        cfDots.className = 'cvf__dots';

        cfEl.appendChild(close);
        cfEl.appendChild(cfMuteBtn);
        cfEl.appendChild(cfPrevBtn);
        cfEl.appendChild(cfNextBtn);
        cfEl.appendChild(stageEl);
        cfEl.appendChild(cfDots);
        document.body.appendChild(cfEl);

        // Delegated click: play/pause when the centre card is tapped; navigate
        // when a side card / side area is tapped (independent of overlap).
        stageEl.addEventListener('click', function (e) {
          if (Date.now() - cfLastSwipe < 500) return;
          var cx = e.clientX,
            cy = e.clientY;
          var rect = cfCards[cfActive].getBoundingClientRect();
          var inCenter = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;
          if (inCenter) {
            cfTogglePlay(cfActive);
            return;
          }
          var target = -1;
          var stack = document.elementsFromPoint(cx, cy);
          for (var k = 0; k < stack.length; k++) {
            var c = stack[k].closest ? stack[k].closest('.cvf__card') : null;
            if (c) {
              var idx = +c.getAttribute('data-i');
              if (idx !== cfActive) {
                target = idx;
                break;
              }
            }
          }
          if (target >= 0) {
            cfGoTo(target);
            return;
          }
          var centerX = (rect.left + rect.right) / 2;
          var withinBand = cy > rect.top - 40 && cy < rect.bottom + 40;
          if (withinBand) cfGoTo(cfActive + (cx > centerX ? 1 : -1));
          else cfClose();
        });

        stageEl.addEventListener(
          'touchstart',
          function (e) {
            var t = e.touches[0];
            cfTouchX = t.clientX;
            cfTouchY = t.clientY;
            cfTouchMoved = false;
          },
          { passive: true }
        );
        stageEl.addEventListener(
          'touchmove',
          function (e) {
            var t = e.touches[0];
            if (Math.abs(t.clientX - cfTouchX) > 8 || Math.abs(t.clientY - cfTouchY) > 8)
              cfTouchMoved = true;
          },
          { passive: true }
        );
        stageEl.addEventListener(
          'touchend',
          function (e) {
            if (!cfTouchMoved) return;
            var t = e.changedTouches[0];
            var dx = t.clientX - cfTouchX,
              dy = t.clientY - cfTouchY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              cfLastSwipe = Date.now();
              cfGoTo(cfActive + (dx < 0 ? 1 : -1));
            }
          },
          { passive: true }
        );

        document.addEventListener('keydown', function (e) {
          if (!cfOpen) return;
          if (e.key === 'Escape') cfClose();
          else if (e.key === 'ArrowLeft') cfGoTo(cfActive - 1);
          else if (e.key === 'ArrowRight') cfGoTo(cfActive + 1);
          else if (e.key === ' ') {
            e.preventDefault();
            cfTogglePlay(cfActive);
          }
        });
      }

      function cfRender() {
        cfCards.forEach(function (card, i) {
          var d = i - cfActive;
          var ad = Math.abs(d);
          var tx, ry, scale, tz, op;
          if (d === 0) {
            tx = 0;
            ry = 0;
            scale = 1;
            tz = 0;
            op = 1;
          } else {
            var dir = d < 0 ? -1 : 1;
            tx = dir * (50 + (ad - 1) * 40);
            ry = -dir * 40;
            scale = Math.max(0.6, 0.82 - (ad - 1) * 0.08);
            tz = -160 - (ad - 1) * 70;
            op = Math.max(0, 1 - ad * 0.32);
          }
          card.style.transform =
            'translate(-50%,-50%) translateX(' +
            tx +
            '%) translateZ(' +
            tz +
            'px) rotateY(' +
            ry +
            'deg) scale(' +
            scale +
            ')';
          card.style.opacity = op;
          card.style.zIndex = 100 - ad;
          card.style.visibility = ad > 3 ? 'hidden' : 'visible';
          card.classList.toggle('is-center', d === 0);
        });
        cfDotEls.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === cfActive);
        });
        if (cfPrevBtn) cfPrevBtn.disabled = cfActive === 0;
        if (cfNextBtn) cfNextBtn.disabled = cfActive === cfCards.length - 1;
      }

      function cfPauseAll() {
        cfVids.forEach(function (v, i) {
          try {
            v.pause();
          } catch (e) {}
          cfCards[i].classList.remove('is-playing');
        });
      }
      function cfPlay(i) {
        cfPauseAll();
        var v = cfVids[i];
        v.muted = cfMuted;
        v.preload = 'auto';
        cfCards[i].classList.add('is-playing');
        var p = v.play();
        if (p && p.catch)
          p.catch(function () {
            cfCards[i].classList.remove('is-playing');
          });
      }
      function cfTogglePlay(i) {
        var v = cfVids[i];
        if (v.paused) cfPlay(i);
        else {
          v.pause();
          cfCards[i].classList.remove('is-playing');
        }
      }
      // Navigate to a card and autoplay it once the scroll settles.
      function cfGoTo(i) {
        i = Math.max(0, Math.min(cfCards.length - 1, i));
        if (cfPendingTimer) {
          clearTimeout(cfPendingTimer);
          cfPendingTimer = null;
        }
        if (i === cfActive) return;
        cfPauseAll();
        cfActive = i;
        cfRender();
        var card = cfCards[cfActive];
        var fired = false;
        var onEnd = function (e) {
          if (e.propertyName !== 'transform' || fired) return;
          fired = true;
          card.removeEventListener('transitionend', onEnd);
          cfPlay(cfActive);
        };
        card.addEventListener('transitionend', onEnd);
        cfPendingTimer = setTimeout(function () {
          if (fired) return;
          fired = true;
          card.removeEventListener('transitionend', onEnd);
          cfPlay(cfActive);
        }, 650);
      }

      function openOverlay(entry, start) {
        if (!entry || !entry.urls.length) return;
        cfEnsure();
        cfTrack.innerHTML = '';
        cfDots.innerHTML = '';
        cfCards = [];
        cfVids = [];

        entry.urls.forEach(function (media, i) {
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'cvf__card';
          card.setAttribute('data-i', i);

          var v = document.createElement('video');
          v.setAttribute('playsinline', '');
          v.muted = cfMuted;
          v.loop = opts.loop;
          v.preload = 'none';
          if (opts.controls) v.controls = true;
          if (media.aspect) v.style.setProperty('--color-video-aspect', media.aspect);
          usePoster(v, media);
          v.src = media.url;
          v.addEventListener('ended', function () {
            card.classList.remove('is-playing');
          });

          var poster = document.createElement('span');
          poster.className = 'cvf__poster';
          var play = document.createElement('span');
          play.className = 'cvf__play';
          play.innerHTML = ICON_PLAY;
          poster.appendChild(play);

          card.appendChild(v);
          card.appendChild(poster);
          cfTrack.appendChild(card);
          cfCards.push(card);
          cfVids.push(v);

          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cvf__dot';
          dot.setAttribute('aria-label', gotoLabel(i + 1));
          (function (idx) {
            dot.addEventListener('click', function () {
              cfGoTo(idx);
            });
          })(i);
          cfDots.appendChild(dot);
        });
        cfDotEls = Array.prototype.slice.call(cfDots.children);

        cfActive = Math.max(0, Math.min(entry.urls.length - 1, start || 0));
        cfOpen = true;
        cfEl.classList.add('is-open');
        cfEl.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        // Pause the inline previews while the overlay is up.
        activeInlineVideos().forEach(function (v) {
          try {
            v.pause();
          } catch (e) {}
        });
        cfRender();
        cfPlay(cfActive); // autoplay the opened video (muted)
      }

      function cfClose() {
        cfPauseAll();
        cfOpen = false;
        if (cfEl) {
          cfEl.classList.remove('is-open');
          cfEl.setAttribute('aria-hidden', 'true');
        }
        document.body.style.overflow = '';
        // Resume the on-screen inline previews.
        activeInlineVideos().forEach(function (v) {
          if (inViewport(v)) safePlay(v);
        });
      }

      // ----- ymq selection wiring -----
      function selectedColorValue() {
        var marked = document.querySelectorAll('input[ymq-option-checked="true"]');
        for (var i = 0; i < marked.length; i++) {
          if (lookup(marked[i].value)) return marked[i].value;
        }
        var checked = document.querySelectorAll('input[type="radio"]:checked');
        for (var j = 0; j < checked.length; j++) {
          if (lookup(checked[j].value)) return checked[j].value;
        }
        return null;
      }
      function syncFromSelection() {
        var val = selectedColorValue();
        if (val != null) applyColor(val);
        else showDefault();
        return val != null;
      }

      showDefault();

      document.addEventListener(
        'click',
        function (e) {
          if (!e.target.closest || !e.target.closest('[class*="ymq-option"]')) return;
          setTimeout(syncFromSelection, 120);
        },
        true
      );

      var container = document.querySelector('#product-detail-vue') || document.body;
      var scheduled = false;
      try {
        new MutationObserver(function () {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(function () {
            scheduled = false;
            syncFromSelection();
          });
        }).observe(container, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['ymq-option-checked', 'checked', 'class', 'aria-checked']
        });
      } catch (e) {}

      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (syncFromSelection() || tries > 40) clearInterval(iv);
      }, 500);
    }

    function initAll() {
      document.querySelectorAll('[data-color-video]').forEach(initBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-protection-checkout"] && !Shopify.designMode) return;
  try {
    class ShippingProtection extends HTMLElement {
    connectedCallback() {
      this.productId = Number(this.dataset.productId);
      this.rate = Number(this.dataset.rate);
      this.variantIds = JSON.parse(this.dataset.variantIds || '[]');
      this.variantPrices = JSON.parse(this.dataset.variantPrices || '[]');

      /* The orphaned-protection fallback renders the skip button only. */
      const withProtection = this.querySelector('[data-sp-checkout]');
      const withoutProtection = this.querySelector('[data-sp-skip]');

      if (withProtection) withProtection.addEventListener('click', () => this.checkout(true));
      if (withoutProtection) withoutProtection.addEventListener('click', () => this.checkout(false));
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    async post(path, body) {
      const response = await fetch(this.root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) throw new Error(path + ' failed: ' + response.status);
      return response.json();
    }

    /* Cheapest variant whose price covers the premium; the top tier is the cap.
       Rounds up exactly like the Liquid above — keep the two in step. */
    tierFor(baseCents) {
      const premium = Math.ceil((baseCents * this.rate) / 100);
      const index = this.variantPrices.findIndex((price) => price >= premium);
      return this.variantIds[index === -1 ? this.variantIds.length - 1 : index];
    }

    baseFor(cart, line) {
      const paid = line ? line.final_line_price : 0;
      const gross =
        this.dataset.base === 'subtotal' ? cart.items_subtotal_price : cart.total_price;
      /* Keep swatch samples out of the base, matching the Liquid above:
         a sample is any non-protection line priced under $10 per unit. */
      const samples = cart.items.reduce((sum, item) => {
        if (item.product_id !== this.productId && item.price < 1000) {
          return sum + item.final_line_price;
        }
        return sum;
      }, 0);
      return Math.max(0, gross - paid - samples);
    }

    async checkout(withProtection) {
      this.setAttribute('aria-busy', 'true');

      /* Protection must never block the sale: on any failure, still check out. */
      try {
        const cart = await (await fetch(this.root + 'cart.js')).json();
        const line = cart.items.find((item) => item.product_id === this.productId);
        /* Samples (under $10) don't count as goods to insure — mirror the Liquid. */
        const hasGoods = cart.items.some(
          (item) => item.product_id !== this.productId && item.price >= 1000
        );
        const wanted = withProtection && hasGoods ? this.tierFor(this.baseFor(cart, line)) : null;

        if (line && line.variant_id !== wanted) {
          await this.post('cart/change.js', { id: line.key, quantity: 0 });
        }

        if (wanted && (!line || line.variant_id !== wanted)) {
          const base = this.baseFor(cart, line);
          await this.post('cart/add.js', {
            items: [
              {
                id: wanted,
                quantity: 1,
                properties: { _protected_amount: (base / 100).toFixed(2) },
              },
            ],
          });
        }
      } catch (error) {
        console.error('[shipping-protection]', error);
      }

      window.location.href = this.root.replace(/\/$/, '') + '/checkout';
    }
  }

  if (!customElements.get('shipping-protection')) {
    customElements.define('shipping-protection', ShippingProtection);
  }
  } catch(e) { console.error(e); }
})();

})();
